import { render, staticRenderFns } from "./ModalContactPreRegister.vue?vue&type=template&id=04063670&scoped=true&"
import script from "./ModalContactPreRegister.vue?vue&type=script&lang=js&"
export * from "./ModalContactPreRegister.vue?vue&type=script&lang=js&"
import style0 from "./ModalContactPreRegister.vue?vue&type=style&index=0&id=04063670&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04063670",
  null
  
)

export default component.exports